import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';

import { NewsSpreadsheetUpload } from '../../NewsSpreadsheetUpload/views/NewsSpreadsheetUpload';
import { Header } from '../components/Header';
import Classification from '../../Classification/views/Classification';
import { HistoryClassification } from '../../ClassificationSpreadsheet/views/HistoryClassification';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { HomeContext } from '../HomeContext';
import { Vehicle } from '../../Vehicle/views/Vehicle';
import { Journalist } from '../../Journalist/views/Journalist';
import { AuthContext } from '../../Authentication/AuthContext';
import { User } from '../../User/views/User';
import { Client } from '../../Client/views/Client';
import { NewsMetric } from '../../ClassificationSpreadsheet/views/NewsMetric';
import { Clipper } from '../../Clipper/views/Clipper';
import { LoadingDialog } from '../../../shared/components/LoadingDialog';
import { StilingueSpreadsheetUpload } from '../../StilingueSpreadsheetUpload/views/StilingueSpreadsheetUpload';
import { KeywordInclusion } from '../../KeywordInclusion/views/KeywordInclusion';
import { HomeItem } from '../components/HomeItem';
import { AlertDialog, createAlertProps } from '../../../shared/components/AlertDialog';
import { InfluencerUpload } from '../../InfluencerSpreadsheetUpload/views/InfluencerUpload';
import { InfluencerHistoryClassification } from '../../InfluencerSpreadsheetUpload/views/InfluencerHistoryClassification';
import ClassificationInfluencer from '../../ClassificationInfluencer/views/ClassificationInfluencer';
import InfluencerHome from '../../InfluencerSpreadsheetUpload/views/InfluencerHome';
import { DashboardInfluencer } from '../../Dashboard/views/DashboardInfluencer';
import { DashboardColgate } from '../../Dashboard/views/DashboardColgate';
import { DashboardGeneric } from '../../Dashboard/views/DashboardGeneric';
import { IDashboard } from '../../../Services/DashboardService';
import InfluencerSubmit from '../../InfluencerSpreadsheetUpload/views/InfluencerSubmit';
import InfluencerProfileClassification from '../../InfluencerSpreadsheetUpload/views/InfluencerProfileClassification';
import InfluencerService from '../../../Services/InfluencerService';
import DashboardService from '../../../Services/DashboardService';
import { AxiosResponse } from 'axios';
import InfluencerClientSelect from '../../InfluencerSpreadsheetUpload/views/InfluencerClientSelect';
import InfluencerClassification from '../../ClassificationInfluencer/views/InfluencerClassification';
import InfluencerSingleProfileSubmit from '../../InfluencerSpreadsheetUpload/views/InfluencerSingleProfileSubmit';
import InfluencerProfileConsult from '../../InfluencerSpreadsheetUpload/views/InfluencerProfileConsult';
import InfluencerSingleCompanySubmit from '../../InfluencerSpreadsheetUpload/views/InfluencerSingleCompanySubmit';
import InfluencerSingleCampaignSubmit from '../../InfluencerSpreadsheetUpload/views/InfluencerSingleCampaignSubmit';
import InfluencerCampaignClassification from '../../InfluencerSpreadsheetUpload/views/InfluencerCampaignClassification';
import InfluencerCompanyClassification from '../../InfluencerSpreadsheetUpload/views/InfluencerCompanyClassification';
import InfluencerCampaignConsult from '../../InfluencerSpreadsheetUpload/views/InfluencerCampaignConsult';
import InfluencerCompanyConsult from '../../InfluencerSpreadsheetUpload/views/InfluencerCompanyConsult';
import CampaignClassification from '../../ClassificationInfluencer/views/CampaignClassification';
import CompanyClassification from '../../ClassificationInfluencer/views/CompanyClassification';
import { DashboardInfluencerBoticario } from '../../Dashboard/views/DashboardInfluencerBoticario';
import { Dashboard } from '../../Dashboard/views/Dashboard';

const useStyles = makeStyles((theme) => createStyles({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.common.white,
    },
    itens: {
        marginTop: '64px'
    }
}));


export function Home() {
    const classes = useStyles();

    const authContext = React.useContext(AuthContext);

    const [pageLocation, setPageLocation] = React.useState<PageLocation>(PageLocation.NONE);
    const [spreadsheetId, setSpreadsheetId] = React.useState<number | null>(null);
    const [openLoadingDialog, setOpenLoadingDialog] = React.useState<boolean>(false);
    const [influencerListClientEnable, setInfluencerListClientEnable] = React.useState<any>();
    const [influencerClientEnable, setInfluencerClientEnable] = React.useState<{ id: number, id_cliente: number, nome: string } | null>(null);
    const [clientsLoaded, setClientsLoaded] = React.useState(false);
    const [selectedDashboard, setSelectedDashboard] = React.useState<IDashboard | null>(null);
    const userClients = authContext.login.user.clients;
    const hasNoClients = !userClients || userClients.length === 0;
    const { alertProps, setAlertProps, showError, showWarning, showSuccess } = createAlertProps();

    React.useEffect(() => {
        if (authContext.login.user.id) {
            InfluencerService.getUserClientEnablements(authContext.login.user.id)
                .then((res: AxiosResponse) => {
                    setInfluencerListClientEnable(res.data);

                    if (res.data.length === 1) {
                        setInfluencerClientEnable(res.data[0]);
                    }
                    setClientsLoaded(true);
                })
                .catch(() => {
                    setClientsLoaded(true);
                    return null;
                });
        }
    }, []);

    React.useEffect(() => {
        if (!clientsLoaded) return;

        if (hasNoClients) {
            setPageLocation(PageLocation.NONE);
        }

        if (authContext.login.user.profile?.functionalities
            && authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Classificação') >= 0)
            setPageLocation(PageLocation.HISTORY);
        else if (authContext.login.user.profile?.functionalities
            && authContext.login.user.profile?.functionalities.length === 1
            && authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso ao Dash') >= 0) {
            DashboardService.getAvailableDashboards()
                .then(dashboards => {
                    const activeDashboards = dashboards.filter(d => d.isActive);
                    if (activeDashboards.length > 0) {
                        setSelectedDashboard(activeDashboards[0]);
                        setPageLocation(PageLocation.DASHBOARD_GENERIC);
                    }
                })
                .catch(error => {
                    console.error('Erro ao buscar dashboards disponíveis:', error);
                });
        }
        else if (authContext.login.user.profile?.functionalities
            && authContext.login.user.profile?.functionalities.findIndex(
                f => f.description == 'Classificação de influencers' ||
                    f.description == 'Cadastro de influencers' ||
                    f.description == 'Acesso ao Dash Influencers' ||
                    f.description == 'Acesso Inicial Influencers') >= 0) {
            if (influencerClientEnable !== null) {
                setPageLocation(PageLocation.INFLUENCER_HOME);
            } else if (userClients && userClients.length > 0) {
                setPageLocation(PageLocation.INFLUENCER_CLIENT_SELECT);
            }
        }
    }, [influencerClientEnable, clientsLoaded, hasNoClients, userClients]);

    return (
        <div className={classes.root}>
            <HomeContext.Provider value={{
                spreadsheetId, setSpreadsheetId,
                pageLocation, setPageLocation,
                openLoadingDialog, setOpenLoadingDialog,
                alertProps, setAlertProps,
                influencerClientEnable, setInfluencerClientEnable,
                influencerListClientEnable, setInfluencerListClientEnable,
                selectedDashboard, setSelectedDashboard,
                showError,
                showWarning,
                showSuccess
            }}>
                <Header />
                <div className={classes.itens}>
                    <HomeItem pageLocation={PageLocation.HISTORY}>
                        <HistoryClassification />
                    </HomeItem>

                    <HomeItem pageLocation={PageLocation.NEWS_UPLOAD}>
                        <NewsSpreadsheetUpload />
                    </HomeItem>

                    <HomeItem pageLocationList={[
                        PageLocation.CLASSIFICATION,
                        PageLocation.REPORT_REVISION,
                        PageLocation.BATCH_CORRECTION,
                        PageLocation.DETACHED_CLASSIFICATION_INITIAL,
                        PageLocation.DETACHED_CLASSIFICATION]}>
                        <Classification />
                    </HomeItem>

                    <HomeItem pageLocation={PageLocation.KEYWORD_INCLUSION}>
                        <KeywordInclusion />
                    </HomeItem>

                    <HomeItem pageLocationList={[
                        PageLocation.JOURNALIST_INPUT,
                        PageLocation.JOURNALIST_SEARCH]}>
                        <Journalist />
                    </HomeItem>

                    <HomeItem pageLocationList={[
                        PageLocation.VEHICLE_INPUT,
                        PageLocation.VEHICLE_EDIT,
                        PageLocation.VEHICLE_SEARCH]}>
                        <Vehicle />
                    </HomeItem>

                    <HomeItem pageLocationList={[
                        PageLocation.USER_INPUT,
                        PageLocation.USER_EDIT,
                        PageLocation.USER_SEARCH]}>
                        <User />
                    </HomeItem>

                    <HomeItem pageLocationList={[
                        PageLocation.CLIENT_INPUT,
                        PageLocation.CLIENT_EDIT,
                        PageLocation.CLIENT_SEARCH]}>
                        <Client />
                    </HomeItem>

                    <HomeItem pageLocation={PageLocation.NEWS_METRIC_IDS}>
                        <NewsMetric />
                    </HomeItem>

                    <HomeItem pageLocationList={[
                        PageLocation.CLIPPER_INPUT,
                        PageLocation.CLIPPER_EDIT,
                        PageLocation.CLIPPER_SEARCH]}>
                        <Clipper />
                    </HomeItem>

                    <HomeItem pageLocation={PageLocation.SOCIAL_MEDIA_UPLOAD}>
                        <StilingueSpreadsheetUpload />
                    </HomeItem>

                    <HomeItem pageLocation={PageLocation.INFLUENCER_UPLOAD}>
                        <InfluencerUpload />
                    </HomeItem>

                    <HomeItem pageLocation={PageLocation.INFLUENCER_HOME}>
                        <InfluencerHome />
                    </HomeItem>

                    <HomeItem pageLocation={PageLocation.INFLUENCER_HISTORY}>
                        <InfluencerHistoryClassification />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.INFLUENCER_PROFILE_CLASSIFICATION}>
                        <InfluencerProfileClassification />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.INFLUENCER_CAMPAIGN_LIST}>
                        <InfluencerCampaignClassification />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.INFLUENCER_COMPANY_LIST}>
                        <InfluencerCompanyClassification />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.INFLUENCER_PROFILE_CONSULT}>
                        <InfluencerProfileConsult />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.INFLUENCER_CAMPAIGN_CONSULT}>
                        <InfluencerCampaignConsult />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.INFLUENCER_COMPANY_CONSULT}>
                        <InfluencerCompanyConsult />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.INFLUENCER_SINGLE_PROFILE_SUBMIT}>
                        <InfluencerSingleProfileSubmit />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.INFLUENCER_SINGLE_COMPANY_SUBMIT}>
                        <InfluencerSingleCompanySubmit />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.INFLUENCER_SINGLE_CAMPAIGN_SUBMIT}>
                        <InfluencerSingleCampaignSubmit />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.INFLUENCER_CLASSIFICATION}>
                        <InfluencerClassification />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.INFLUENCER_CAMPAIGN_CLASSIFICATION}>
                        <CampaignClassification />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.INFLUENCER_COMPANY_CLASSIFICATION}>
                        <CompanyClassification />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.INFLUENCER_SUBMIT}>
                        <InfluencerSubmit />
                    </HomeItem>
                    {userClients && userClients.length > 0 && (
                        <HomeItem pageLocation={PageLocation.INFLUENCER_CLIENT_SELECT}>
                            <InfluencerClientSelect />
                        </HomeItem>
                    )}

                    <HomeItem pageLocation={PageLocation.CLASSIFICATION_INFLUENCER}>
                        <ClassificationInfluencer />
                    </HomeItem>
                    {/* <HomeItem pageLocation={PageLocation.DASHBOARD}>
                        <Dashboard />
                    </HomeItem> */}
                    <HomeItem pageLocation={PageLocation.DASHBOARD_INFLUENCER}>
                        <DashboardInfluencer />
                    </HomeItem>

                    <HomeItem pageLocation={PageLocation.DASHBOARD_INFLUENCER_BOTICARIO}>
                        <DashboardInfluencerBoticario />
                    </HomeItem>

                    <HomeItem pageLocation={PageLocation.DASHBOARD_COLGATE}>
                        <DashboardColgate />
                    </HomeItem>
                    <HomeItem pageLocation={PageLocation.DASHBOARD_GENERIC}>
                        <DashboardGeneric />
                    </HomeItem>

                    <HomeItem pageLocation={PageLocation.FAQ}>
                        <InfluencerHome />
                    </HomeItem>

                </div>
                <LoadingDialog open={openLoadingDialog} />
                <AlertDialog
                    message={alertProps.message}
                    onClose={alertProps.onClose}
                    open={alertProps.open}
                    severity={alertProps.severity}
                />
            </HomeContext.Provider>
        </div>
    );
}